import request from '../utils/request';

//观众登录
export function login(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/onlineExhibition/frontAudience/login',
    method: 'post',
    data: formData,
  });
}
//展商注销
export function logout(data) {
  return request({
    url: '/onlineExhibition/signOut',
    method: 'get',
    params: data,
  });
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/onlineExhibition/audienceRetrievePassword',
    method: 'post',
    data: data,
  });
}

// 发送验证码
export function sendCode(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontExhibitor/phoneCode/sendCode',
    method: 'post',
    data: formData,
  });
}
